import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, Save } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { errMsg } from "@/lib/api";
import { Field, inp } from "@/components/admin/AdminUi";
import { cassa } from "./cassaApi";

const EMPTY = { kind: "azienda", company: "", first_name: "", last_name: "", vat: "", cf: "", address: "", civic: "", zip: "", city: "", province: "", country: "IT", sdi: "", pec: "", email: "", phone: "", notes: "" };

export function ClientForm({ client, onClose, onSaved }) {
  const [f, setF] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (client) setF({ ...EMPTY, ...client }); }, [client]);
  const set = (k, up) => (e) => setF({ ...f, [k]: up ? e.target.value.toUpperCase() : e.target.value });
  const I = (k, label, p = {}) => <Field label={label} wide={p.wide}><input data-testid={`cassa-client-${k}`} className={inp + (p.mono ? " font-mono" : "")} value={f[k]} onChange={set(k, p.up)} maxLength={p.max} placeholder={p.ph} /></Field>;
  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const body = Object.fromEntries(Object.keys(EMPTY).map((k) => [k, f[k] ?? ""]));
      const { data } = f.id ? await cassa.put(`/clients/${f.id}`, body) : await cassa.post("/clients", body);
      toast.success("Anagrafica salvata");
      onSaved(data);
    } catch (x) { toast.error(errMsg(x)); }
    setBusy(false);
  };
  return (
    <Dialog open={!!client} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-2xl max-h-[92vh] overflow-y-auto" data-testid="cassa-client-dialog">
        <DialogHeader><DialogTitle className="text-2xl font-extrabold uppercase">{f.id ? "Modifica cliente" : "Nuovo cliente cassa"}</DialogTitle></DialogHeader>
        <form onSubmit={save} className="grid sm:grid-cols-2 gap-3">
          <div className="sm:col-span-2 flex gap-2">
            {[["azienda", "Azienda / professionista"], ["privato", "Privato"]].map(([k, l]) => (
              <button type="button" key={k} data-testid={`cassa-client-kind-${k}`} onClick={() => setF({ ...f, kind: k })} className={`press h-9 px-3 rounded-full border text-sm font-semibold ${f.kind === k ? "bg-brand-navy text-white border-brand-navy" : "bg-white"}`}>{l}</button>
            ))}
          </div>
          {f.kind === "azienda" ? I("company", "Ragione sociale *", { wide: true }) : <>{I("first_name", "Nome *")}{I("last_name", "Cognome *")}</>}
          {I("vat", "Partita IVA", { mono: true, max: 11, ph: "11 cifre" })}
          {I("cf", f.kind === "privato" ? "Codice fiscale (serve per la fattura)" : "Codice fiscale", { mono: true, up: true, max: 16 })}
          {I("sdi", "Codice destinatario SDI", { mono: true, up: true, max: 7, ph: "0000000 se usa la PEC" })}
          {I("pec", "PEC")}
          {I("address", "Indirizzo")}
          {I("civic", "N. civico")}
          {I("zip", "CAP", { max: 5 })}
          {I("city", "Comune")}
          {I("province", "Provincia", { up: true, max: 2, ph: "FC" })}
          {I("country", "Nazione (codice)", { up: true, max: 2 })}
          {I("email", "Email")}
          {I("phone", "Telefono")}
          {I("notes", "Note", { wide: true })}
          <button data-testid="cassa-client-save-btn" disabled={busy} className="sm:col-span-2 press h-11 rounded-md bg-brand-yellow text-brand-navy font-semibold flex items-center justify-center gap-2 disabled:opacity-60">
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />} Salva anagrafica
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
